import { Checkbox } from '@mui/material';
import { isChecked } from '../../../utils';

export const CheckboxCellRenderer = ({ propertyName, ...props }) => {
    return props?.data.hasOwnProperty(propertyName) ? (
        <Checkbox checked={isChecked(props?.data[propertyName])} disabled style={{ padding: 0 }} />
    ) : null;
};
